/** 可 dispose 的最新帧下发器：dispose 后丢弃在途与 pending 帧 */
export type LatestFrameSender<T> = ((payload: T) => Promise<void>) & {
  dispose: () => void;
};

/**
 * 2.4G 等慢链路：串行下发 + 飞行中只保留最新一帧，避免并发堆积又尽量跟手。
 */
export function createLatestFrameSender<T>(
  sendOne: (payload: T) => Promise<void>
): LatestFrameSender<T> {
  let sendInFlight = false;
  let pending: T | null = null;
  let disposed = false;

  const drain = async (payload: T) => {
    if (disposed) return;
    if (sendInFlight) {
      pending = payload;
      return;
    }
    sendInFlight = true;
    let batch = payload;
    try {
      for (;;) {
        if (disposed) break;
        try {
          await sendOne(batch);
        } catch (e) {
          console.warn("[musicRhythm] 律动下发失败（已吞掉避免红屏）:", e);
        }
        const next = pending;
        pending = null;
        if (next === null) break;
        batch = next;
      }
    } finally {
      sendInFlight = false;
    }

    if (disposed) {
      pending = null;
      return;
    }
    const tail = pending;
    if (tail !== null) {
      pending = null;
      void drain(tail);
    }
  };

  const send = ((payload: T) => drain(payload)) as LatestFrameSender<T>;
  send.dispose = () => {
    disposed = true;
    pending = null;
  };
  return send;
}
